import moment from "moment";

export const formatDate = date => (date ? moment(date).format("DD.MM.YYYY") : "-");

export const formatDateTime = date => (date ? moment(date).format("DD.MM.YYYY HH:mm") : "-");

export const formatFullDateTime = date =>
    date ? moment(date).format("DD.MM.YYYY HH:mm:ss") : "-";

const unique = values => [...new Set(values.filter(Boolean))];

export const getZoneManagementLabel = application =>
    unique((application.zones || []).map(zone => zone.zoneManagementName)).join(", ") || "-";

export const getZoneLabel = application =>
    unique((application.zones || []).map(zone => zone.zoneName)).join(", ") || "-";

export const getCityDistrictLabel = (application, type) => {
    const districts =
        type === "company"
            ? [application.district?.name]
            : (application.districts || []).map(district => district.name);
    return [application.city?.name, unique(districts).join(", ")].filter(Boolean).join(" / ") || "-";
};

export const getApplicationTitle = (application, type) =>
    (type === "company" ? application.companyName : application.fullName) || "-";

export const getDetailRoute = (type, id) => `/applications/${type}/${id}`;
